import { Injectable } from '@angular/core';
import { BrandingAccess } from '@rx-applications/shared/branding/utils';
import { Appearance } from '@stripe/stripe-js';
import { roomexStripeAppearance } from '../constants/roomex-stripe-appearance';
import { roomexTermsAndConditions } from '../constants/roomex/roomexTermsAndConditions';
import { supportedLanguages } from '@rx-applications/clientsite/shared/internationalization/data-access';

@Injectable({
  providedIn: 'root',
})
export class RoomexBrandingAccessService implements BrandingAccess {
  getMetaTagColor(): string {
    return '#008793'; // $color-teal-dark
  }

  getFavicon(): string {
    return '/assets/images/favicon.png';
  }

  getNoDataImagePath(): string {
    return '/assets/images/empty-data-roomex.png';
  }

  getLogoHeightInPx(): number {
    return 48;
  }

  invoicelogoImagePlacing(): number[] {
    return [422, 0, 0, 165, 64];
  }

  getLogoFullUrl(): string {
    return './assets/images/logos/logo_full_roomex.svg';
  }
  
  getInvoiceLogoUrl(): string {
    return '/assets/images/logos/logo_full_roomex.png';
  }
  
  getPieChartColours(): string[] {
    return ['#00B7B1', '#3977C1', '#AC4FC6', '#D32F2F', '#FBC02D', '#3C9040'];
  }

  getStripeAppearance(): Appearance {
    return roomexStripeAppearance;
  }

  getDefaultTitle(): string {
    return 'Roomex is a Global Hotel Booking Platform for Business Travel, Corporate Travel Management Company';
  }

  getTranslationPath(): string {
    return '/roomex';
  }

  getTheme(): string {
    return 'roomex';
  }

  getTermsAndConditions(): string {
    return roomexTermsAndConditions;
  }

  getHotelLocationPinUrl(): string {
    return '/assets/images/map/hotel_location.svg';
  }

  getPriceActivePinUrl(): string {
    return '/assets/images/map/price-pin-active.svg';
  }

  getPricePinUrl(): string {
    return '/assets/images/map/price-pin.svg';
  }

  getEmailSupportContact(): string {
    return 'support.us@roomex.com';
  }

  getContactName(): string {
    return 'Roomex USA';
  }

  shouldDisplayContact(): boolean {
    return true;
  }

  getSupportedLanguages() {
    return supportedLanguages;
  }

  shouldShowIosModal() {
    return true;
  }
}
